import SettingsWelcomeScreenRoute from 'garaje/pods/visitors/settings/welcome-screen/design/route';

export default class VirtualFrontDeskSettingsWelcomeScreenDesignRoute extends SettingsWelcomeScreenRoute {
  controllerName = 'visitors/settings/welcome-screen/design';
  templateName = 'visitors/settings/welcome-screen/design';

  titleToken = 'Design';
}
